import { GridChildComponentProps } from '@apps/admin/common/VirtualScroll';
import { MediaPhoto as MediaPhotoQueryResult } from '../../routes/ViewCollection/components/PhotoUploader/PhotoUploader.types';

export enum PICKER_TYPES {
  ADD_TO_COLLECTION = 'ADD_TO_COLLECTION',
  PICK_FROM_ALL_PHOTOS = 'PICK_FROM_ALL_PHOTOS',
}

export type PhotoPickerDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleOpenFilePicker: () => void;
  isFetching: boolean;
  media?: MediaPhotoQueryResult[] | null;
  handleAddMedia: (selectedItemsId: string[], cbOnSuccess: () => void) => void;
  isAddingMedia: boolean;
  collectionId?: string;
  showCount?: boolean;
  pickerType?: PICKER_TYPES;
  maxCount?: number;
  minCount?: number;
  photoSelectionHelperText?: string;
  selectedItems?: string[];
  disabledItems?: string[];
  uploadInProgressCount?: number;
};

export type PhotoPickerLibraryProps = {
  handleClose: () => void;
  isFetching: boolean;
  media?: MediaPhotoQueryResult[] | null;
  selectedItemsId: string[];
  disabledItems: string[];
  updateSelectedItemsId: (newSelectedItemId: string) => void;
  handleOpenFilePicker: () => void;
  showCount?: boolean;
  pickerType?: PICKER_TYPES;
  photoSelectionHelperText?: string;
  uploadInProgressCount?: number;
};

export type DialogFooterProps = {
  handleSelectAll?: () => void;
  handleDeselect?: () => void;
  handleCancel: () => void;
  handleAdd: () => void;
  isAdding: boolean;
  disableAddCTA: boolean;
  disableSelectAllCTA?: boolean;
  disableDeselectAllCTA?: boolean;
  showBulkActionCTAs?: boolean;
  pickerType?: PICKER_TYPES;
  selectedItemsCount?: number;
};

export type MediaPhoto = {
  id: string;
  photo: {
    id: string;
    url: string;
    height: number;
    width: number;
  };
};

export type GridItemProps = GridChildComponentProps<{
  mediaArray: MediaPhoto[];
  updateSelectedItemsId: (newSelectedItemId: string) => void;
  selectedItemsId: string[];
  disabledItems: string[];
  showCount: boolean;
}>;
